import log4javascript from 'log4javascript';

//http://log4javascript.org/docs/manual.html

const LOGGER = log4javascript.getLogger();

//tworzymy appender do przegladarki (domyslnie jest popup)
const loggerAppender = new log4javascript.BrowserConsoleAppender();
//tworzymy wzór loggera
//const loggerLayout = new log4javascript.PatternLayout("[%-5p] %m");
//loggerAppender.setLayout(loggerLayout);

LOGGER.addAppender(loggerAppender);

//log level domyślnie jest debug, ale nie dziala na chrome, na IE tak
//LOGGER.setLevel(log4javascript.Level.DEBUG);

export default LOGGER;